import type { UserId } from '@/schemas/ids';
import { downloadRemoteGameDefinitions } from './download';
import { mergeRemoteGameDefinitions } from './merge';
import { uploadPendingGameDefinitions } from './upload';

export interface SyncResult {
  uploadedCount: number;
  downloadedCount: number;
}

export class GameDefinitionsSyncError extends Error {
  constructor(
    message: string,
    public readonly userId: UserId,
    public readonly type: 'upload' | 'download' | 'full',
    public readonly originalError: unknown,
  ) {
    super(message);
    this.name = 'GameDefinitionsSyncError';
  }
}

export async function syncGameDefinitions(userId: UserId): Promise<SyncResult> {
  try {
    const up = await uploadPendingGameDefinitions(userId);
    const down = await downloadRemoteGameDefinitions(userId);
    await mergeRemoteGameDefinitions(down.definitions);
    return { uploadedCount: up.uploaded, downloadedCount: down.definitions.length };
  } catch (error) {
    throw new GameDefinitionsSyncError(
      error instanceof Error ? error.message : 'Game definitions sync failed',
      userId,
      'full',
      error,
    );
  }
}
